const userKinds = {
    1: { title: "کاربر", enTitle: "user" },
    2: { title: "تامین کننده", enTitle: "provider" },
    3: { title: "مدیر", enTitle: "admin" },
    4: { title: "مهمان", enTitle: "guest" },
}

export default userKinds;